import { Box, DatePicker, FormGroup, FormLabel, Heading } from '@ksyos/design-system';
import type { ValidationErrors } from '@frontend/utils';
import { getSelectedLanguage } from '@frontend/translate';
import { getValidationErrorTranslation } from '@frontend/utils';
import type { ISearchParams } from '../requestFinancialExportUtils';

interface IRequestFinancialExportPeriodFilterProps {
    endDate?: Date;
    errors: ValidationErrors;
    isDisabled: boolean;
    onChange: (filterName: keyof ISearchParams, value?: Date | null) => void;
    startDate?: Date;
}

export function RequestFinancialExportPeriodFilter(props: IRequestFinancialExportPeriodFilterProps) {
    const language = getSelectedLanguage();

    return (
        <>
            <Heading
                marginY={3}
                size="small"
            >
                {language.common.period}
            </Heading>
            <FormGroup
                hasErrors={props.errors.has('startDate') || props.errors.has('endDate')}
                isRequired={true}
                label={language.common.startDateAndEndDate}
            >
                <Box display="flex">
                    <DatePicker
                        error={getValidationErrorTranslation(props.errors.get('startDate'))}
                        isDisabled={props.isDisabled}
                        onChange={(value) => {
                            props.onChange('startDate', value);
                        }}
                        sx={{ maxWidth: '170px' }}
                        value={props.startDate || null}
                    />
                    <FormLabel sx={{ margin: 2 }}>{language.common.upToAndIncluding}</FormLabel>
                    <DatePicker
                        error={getValidationErrorTranslation(props.errors.get('endDate'))}
                        isDisabled={props.isDisabled}
                        onChange={(value) => {
                            props.onChange('endDate', value);
                        }}
                        sx={{ maxWidth: '170px' }}
                        value={props.endDate || null}
                    />
                </Box>
            </FormGroup>
        </>
    );
}
